import { useLocalTranslation } from "@/hooks/useLocalTranslation"
import EmdiSkillLogo1 from "@/assets/icons/emdiSkillLogo1.png"
import DarkLogo from "@/assets/icons/darkModeEmediSjillLogo1.png";
import EmdiSkillLogo2 from "@/assets/icons/emdiSkillLogo2.png"
import BlackSearch from "@/assets/icons/blackSearch.png"
import WhiteSearch from "@/assets/icons/whiteSearch.png"

import GreySearch from "@/assets/icons/greySearch.png"

import BlackLeftArrow from "@/assets/icons/blackLeftArrow.png"
import BackWhiteIcon from '@/assets/dashboard/navItems/backWhiteIcon.png'

import { useEffect, useRef, useState } from "react"
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState } from "@/store"
import { allPaths, allQueryParam } from "@/constants/urlPaths"
import { addCurrentThemeClassToEle, hasQueryParam, isUrlPath } from "@/utils"
import "./style.css"
import { useAuthToken } from "@/hooks/useAppSelectors"
import { themes } from "@/constants/colors_v2";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

const NavBar = (props: any) => {
    const token = useAuthToken()
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const { top: safeAreaTop } = useSafeAreaInsets();
    const searchQuery = searchParams.get("search_query");
    const sourceComingrom = location.state?.source;
    const purchaseId = location.state?.purchaseId;


    const { common } = useLocalTranslation();
    const navigate = useNavigate();
    const [searchVal, setSearchVal] = useState("")
    const [searchBarIsVisible, setSearchBarIsVisible] = useState(true)

    const videoDetails = useSelector((state: RootState) => state.videoReducer.video);
    const seriesDetails = useSelector((state: RootState) => state.seriesReducer.series);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const [searchBarIsFocused, setSearchBarIsFocused] = useState(false);

    useEffect(() => {
        handleVisiblityOfSearchBar()
        handleSearchQuery()
    }, [searchQuery])


    const handleVisiblityOfSearchBar = () => {
        if (hasQueryParam(allQueryParam.series)
            || hasQueryParam(allQueryParam.searchQuery)) {
            setSearchBarIsVisible(true)
        } else {
            setSearchBarIsVisible(false)
        }
    }

    const handleSearchQuery = () => {
        if (searchQuery && searchQuery != "") {
            setSearchVal(searchQuery)
        }
    }
    // tetsing
    // useEffect(() => {
    //     console.log("videoDetails ", videoDetails)
    //     console.log("seriesDetails ", seriesDetails)
    // }, [videoDetails, seriesDetails])

    const handleSearchChange = (event: any) => {
        const val = event.target.value
        setSearchVal(val)
    }

    const onSearchClick = (val?: string) => {
        const finalSearch = val ?? searchVal;

        if (finalSearch !== "") {
            addRecentSearch(finalSearch.trim());
            setRecentSearches(getRecentSearches());

            const navigate_ = `/search?search_query=${finalSearch}`;
            // navigate(`/search?search_query=${searchVal}`, {
            //     state: {
            //         source: source,
            //     },
            // });

            navigate(navigate_);

            if (inputRef.current) {
                inputRef.current?.blur();
            }
        }
    }

    const handleBack = () => {
        if (!token) {
            //@ts-ignore
            window.location.href = process.env.REACT_APP_REDIRECT
            return
        }
        let navigate_: any = allPaths.dashboard
        if (sourceComingrom) {
            if (sourceComingrom === allPaths.dashboard) {
                navigate_ = allPaths.dashboard
            } else if (sourceComingrom === allPaths.timeline && purchaseId) {
                navigate_ = `${allPaths.timeline}/${purchaseId}`
            }
        } else {
            if (isUrlPath(allPaths.search)) {
                if (videoDetails && seriesDetails && seriesDetails.length > 0) {
                    const seriesId = seriesDetails[0].seriesId
                    const videoDocId = videoDetails._id
                    navigate_ = `/watch?series=${seriesId}&video=${videoDocId}`
                }
            }
        }
        // console.log(navigate_, "handlBack nav bar")
        navigate(navigate_);
    }






    // START : code for recent seacr hand localstorage
    useEffect(() => {
        if (searchBarIsFocused) {
            setRecentSearches(getRecentSearches());
        }
    }, [searchBarIsFocused]);
    const inputRef = useRef<HTMLInputElement>(null);
    const [recentSearches, setRecentSearches] = useState<string[]>([]);
    const RECENT_SEARCHES_KEY = "recent_searches";
    const getRecentSearches = (): string[] => {
        const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
        return stored ? JSON.parse(stored) : [];
    };
    const addRecentSearch = (term: string): void => {
        let searches = getRecentSearches();
        // Remove if already present to re-add on top
        searches = searches.filter(item => item.toLowerCase() !== term.toLowerCase());
        searches.unshift(term); // Add new term to the front
        if (searches.length > 3) {
            searches = searches.slice(0, 3); // Keep only latest 3
        }
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
    };
    const handleRcentSearch = (search: string) => {
        setSearchVal(search)
        onSearchClick(search)
    }
    // END : code for recent seacr hand localstorage

    return (
        <div className={`videoNavBar fixed 
            top-[-45px]
            max-[1280px]:top-0
            left-0 
            min-[1280px]:mt-0
            max-[1280px]:px-[20px]
            max-[1350px]:px-[80px]
            max-[1500px]:px-[100px]
            px-[230px] 
            shadow-none 
        ${addCurrentThemeClassToEle(currentTheme, 'videoNavBar')}`}
        style={{ 
            marginTop : `calc(45px + ${safeAreaTop}px)`
        }}
        >
            <img
                onClick={handleBack}
                className="blackLeftArrow ms-0 mr-5"
                src={currentTheme === themes.dark ? BackWhiteIcon : BlackLeftArrow} 
                alt="BlackLeftArrow" />

            {/* <Link to={process.env.REACT_APP_USER_PANEL_URL ? process.env.REACT_APP_USER_PANEL_URL : "#"}>
                <img
                    className="emdiSkillLogo1"
                    src={currentTheme === themes.dark ? DarkLogo : EmdiSkillLogo1} 
                    alt="EmdiSkillLogo1" />
            </Link> */}


            {/* <Link to={process.env.REACT_APP_USER_PANEL_URL ? process.env.REACT_APP_USER_PANEL_URL : "#"}>
                <img
                    className="emdiSkillLogo2"
                    src={EmdiSkillLogo2} alt="EmdiSkillLogo2" />
            </Link> */}


            {searchBarIsVisible &&
                <div className=" w-full mr-[15px]">
                    <div className="searchCon1 flex items-center relative z-10">
                        <img
                            onClick={() => onSearchClick()}
                            className="blackSearch"
                            src={currentTheme === themes.dark ? WhiteSearch : BlackSearch}
                            alt="BlackSearch"
                        />
                        <input
                            type="text"
                            ref={inputRef}
                            value={searchVal}
                            onChange={handleSearchChange}
                            onFocus={() => setSearchBarIsFocused(true)}
                            onBlur={() => setTimeout(() => setSearchBarIsFocused(false), 100)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    onSearchClick();
                                }
                            }}
                            placeholder={common.statusText.searchVideos}
                            className="flex-1 focus:outline-none text-gray-800 text-[16px]"
                        />
                    </div>

                    {searchBarIsFocused && recentSearches.length > 0 && (
                        // {true && (
                        <div className="searchOverlay absolute top-full left-0 w-full shadow-md z-20">
                            <p className="recentSearchText">{common.statusText.recentSearches}</p>
                            {recentSearches.map((item, index) => (
                                <div
                                    onMouseDown={() => handleRcentSearch(item)}
                                    className="recentSearchRow mb-[8px] last:mb-0" key={index}>
                                    <img
                                        className="greySearch"
                                        src={currentTheme === themes.dark ? WhiteSearch : GreySearch} 
                                        alt="GreySearch" />
                                    <p className="recentSearchItem">{item}</p>
                                </div>
                            ))}

                        </div>
                    )}
                </div>
            }


        </div>
    );
};

export default NavBar;
